<template>
  <el-dialog :visible.sync="visible" width="960px" append-to-body :close-on-click-modal="false" @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="mpsSchedule" :biz-id="form.mpsScheduleId" perm="production:mpsSchedule" :approve-status="String(form.approveStatus || '0')" @approve="approve(true)" @unapprove="approve(false)" />
            <el-button v-if="(isAuth('production:mpsSchedule:update') || isAuth('production:mpsSchedule:save')) && form.approveStatus !== '2'" type="primary" size="small" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('production:mpsSchedule:delete') && form.approveStatus !== '2'" type="primary" size="small" @click="remove">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="10">
        <el-col :span="8"><el-form-item label="计划单号"><el-input v-model="form.mpsScheduleCode" :disabled="formDisabled || !!form.mpsScheduleId" placeholder="留空自动编号" /></el-form-item></el-col>
        <el-col :span="8"><el-form-item label="业务日期" prop="scheduleDate"><el-date-picker v-model="form.scheduleDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formDisabled" style="width:100%" /></el-form-item></el-col>
        <el-col :span="8"><el-form-item label="计划区间起"><el-date-picker v-model="form.planStartDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" disabled style="width:100%" /></el-form-item></el-col>
        <el-col :span="8"><el-form-item label="计划区间止"><el-date-picker v-model="form.planEndDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" disabled style="width:100%" /></el-form-item></el-col>
        <el-col :span="16"><el-form-item label="备注"><el-input v-model="form.remark" :disabled="formDisabled" /></el-form-item></el-col>
      </el-row>
      <div v-if="!formDisabled" style="margin-bottom:8px"><el-button type="primary" size="small" @click="materialSelectorVisible = true">添加物料</el-button></div>
      <el-table :data="form.lines" border size="small" :header-cell-style="headStyle">
        <el-table-column label="物料编码" min-width="110">
          <template slot-scope="s"><el-input v-model="s.row.materialCode" size="small" :disabled="formDisabled" @blur="fillMaterial(s.row)" /></template>
        </el-table-column>
        <el-table-column prop="materialName" label="物料名称" min-width="120" />
        <el-table-column label="需求类型" width="130">
          <template slot-scope="s">
            <el-select v-model="s.row.demandType" :disabled="formDisabled" size="small" style="width:100%">
              <el-option label="计划独立需求" value="independent" />
              <el-option label="预测" value="forecast" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="期间起" width="150">
          <template slot-scope="s"><el-date-picker v-model="s.row.periodStart" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formDisabled" size="small" style="width:100%" /></template>
        </el-table-column>
        <el-table-column label="期间止" width="150">
          <template slot-scope="s"><el-date-picker v-model="s.row.periodEnd" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formDisabled" size="small" style="width:100%" /></template>
        </el-table-column>
        <el-table-column label="计划数量" width="120">
          <template slot-scope="s"><el-input-number v-model="s.row.plannedQty" :disabled="formDisabled" :min="0.000001" :precision="2" size="small" style="width:100%" /></template>
        </el-table-column>
        <el-table-column v-if="!formDisabled" label="操作" width="70" align="center">
          <template slot-scope="s"><el-button type="text" @click="form.lines.splice(s.$index, 1)">删</el-button></template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formDisabled" type="primary" @click="save">保存</el-button>
    </span>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="true" @select-multiple="onMaterials" />
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import MaterialSelector from '../../components/MaterialSelector.vue'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' 00:00:00'
}

export default {
  name: 'MpsScheduleAddOrUpdate',
  components: { WorkflowDocButtons, MaterialSelector },
  data() {
    return {
      visible: false,
      readonly: false,
      materialSelectorVisible: false,
      permCodes: [],
      form: { lines: [] },
      headStyle: { background: '#f5f7fa', color: '#606266' },
      rules: { scheduleDate: [{ required: true, message: '业务日期不能为空', trigger: 'change' }] }
    }
  },
  computed: {
    formDisabled() { return this.readonly || String(this.form.approveStatus) === '2' },
    showViewToolbar() { return this.readonly && !!this.form.mpsScheduleId },
    dialogTitle() {
      if (this.readonly) return '查看主生产计划'
      return this.form.mpsScheduleId ? '修改主生产计划' : '新增主生产计划'
    }
  },
  created() { this.loadPerms() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    blankLine() { return { materialId: '', materialCode: '', materialName: '', demandType: 'independent', periodStart: '', periodEnd: '', plannedQty: 1 } },
    onMaterials(rows) {
      const exists = new Set((this.form.lines || []).map(l => l.materialId).filter(Boolean))
      ;(rows || []).forEach(row => {
        if (!row || !row.materialId || exists.has(row.materialId)) return
        exists.add(row.materialId)
        this.form.lines.push({
          materialId: row.materialId,
          materialCode: row.materialCode || '',
          materialName: row.materialName || '',
          demandType: 'independent',
          periodStart: this.form.planStartDate || '',
          periodEnd: this.form.planEndDate || '',
          plannedQty: 1
        })
      })
    },
    onClosed() {
      this.readonly = false
      this.materialSelectorVisible = false
      this.form = { lines: [] }
    },
    init(row, readonly) {
      this.visible = true
      this.readonly = !!readonly
      const hasLines = !!(row && Array.isArray(row.lines))
      this.form = row ? { ...row, planStartDate: row.planStartDate || '', planEndDate: row.planEndDate || '', lines: hasLines ? row.lines : [] } : { mpsScheduleCode: '', scheduleDate: today(), planStartDate: '', planEndDate: '', remark: '', lines: [] }
      if (row && row.mpsScheduleId && !hasLines) {
        request.get('/plan/mps/lines', { params: { id: row.mpsScheduleId } }).then(res => { this.form.lines = res.data || [] }).catch(() => {})
      }
    },
    fillMaterial(row) {
      const code = (row.materialCode || '').trim()
      if (!code) return
      request.get('/base/material/byCode', { params: { materialCode: code } }).then(res => {
        const m = res.data || {}
        row.materialId = m.materialId || ''
        row.materialName = m.materialName || ''
        row.materialCode = m.materialCode || code
      }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.form.lines.length || this.form.lines.some(line => !line.materialId)) {
          this.$message.warning('请填写物料编码')
          return
        }
        request.post('/plan/mps/save', {
          mpsScheduleId: this.form.mpsScheduleId,
          mpsScheduleCode: this.form.mpsScheduleCode,
          scheduleDate: this.form.scheduleDate,
          remark: this.form.remark,
          lines: this.form.lines.map(line => ({
            materialId: line.materialId, materialCode: line.materialCode, materialName: line.materialName,
            demandType: line.demandType, periodStart: line.periodStart, periodEnd: line.periodEnd, plannedQty: line.plannedQty
          }))
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      })
    },
    approve(pass) {
      const id = this.form.mpsScheduleId
      this.$confirm(pass ? '确定审核?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {
        request.post(pass ? '/plan/mps/approve' : '/plan/mps/unapprove', { id }).then(() => {
          this.$message.success(pass ? '审核成功' : '弃审成功')
          this.$set(this.form, 'approveStatus', pass ? '2' : '0')
          this.readonly = true
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    remove() {
      this.$confirm('确定删除这张未审核主生产计划?', '提示', { type: 'warning' }).then(() => {
        request.post('/plan/mps/delete', { id: this.form.mpsScheduleId }).then(() => { this.$message.success('已删除'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.doc-dialog-actions .el-button { margin-left: 0; }
</style>
